/* RAVU · script do tema (porta de prototipo/assets/app.js para a Shopify)
   - abre e fecha menu, carrinho, quiz e stories ([data-open] / [data-close])
   - carrinho lateral com o carrinho real da loja (/cart.js), frete grátis, sugestão e cupom
   - carrosséis, banner de campanhas, abas de tabela nutricional, filtros, animações de rolagem
   API para as páginas: window.RAVU.carrinho.adicionar([{ id, quantity, properties }]), RAVU.toast(), RAVU.abrir(), RAVU.animar() */
(function () {
  const C = window.RAVU_CONFIG || { rotas: {}, freteGratis: 0, parcelas: 3 };
  const R = (window.RAVU = window.RAVU || {});
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const calmo = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const brl = centavos => (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: C.moeda || 'BRL' });
  const parcela = centavos => `Ou ${C.parcelas}x de ${brl(Math.round(centavos / C.parcelas))} sem juros`;
  const esc = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const rota = (nome, padrao) => (C.rotas && C.rotas[nome]) || padrao;
  Object.assign(R, { $, $$, brl, parcela, esc });

  /* catálogo (snippet ravu-catalogo) */
  let catalogo = [];
  try { catalogo = JSON.parse($('#ravu-catalogo')?.textContent || '{}').produtos || []; } catch (e) { catalogo = []; }
  const porHandle = h => catalogo.find(p => p.handle === h);
  const porVariante = id => catalogo.find(p => p.variantes && p.variantes[id]);
  R.catalogo = catalogo;

  /* ---------- abrir/fechar painéis ---------- */
  let ultimoFoco = null;
  function abrir(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    ultimoFoco = document.activeElement;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => el.querySelector('[data-close].icon-btn, .x')?.focus(), 50);
    if (id === 'cart') carrinho.atualizar();
    return true;
  }
  function fechar(el) {
    if (!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.open, .modal.open')) document.documentElement.style.overflow = '';
    ultimoFoco?.focus?.();
    if (el.id === 'quiz') {
      const passo = $('#qStep'), res = $('#qResult');
      if (passo) passo.style.display = '';
      if (res) res.style.display = 'none';
    }
    el.dispatchEvent(new CustomEvent('ravu:fechou', { bubbles: true }));
  }
  document.addEventListener('click', e => {
    const abre = e.target.closest('[data-open]');
    if (abre) {
      if (abrir(abre.dataset.open)) e.preventDefault();
      return;
    }
    const fecha = e.target.closest('[data-close]');
    if (fecha) { fechar(fecha.closest('.drawer, .modal')); return; }
    if (e.target.classList?.contains('modal')) fechar(e.target);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') $$('.drawer.open, .modal.open').forEach(fechar);
  });
  R.abrir = abrir;
  R.fechar = fechar;

  /* ---------- acordeões: abrir um fecha os outros do mesmo bloco ---------- */
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (d.tagName !== 'DETAILS' || !d.open) return;
    const caixa = d.closest('#list, .faqbig') || d.closest('.info, .faq, .qa');
    caixa?.querySelectorAll('details[open]').forEach(x => { if (x !== d) x.open = false; });
  }, true);

  /* ---------- aviso ---------- */
  let tempoAviso;
  function toast(msg) {
    const t = $('#toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(tempoAviso);
    tempoAviso = setTimeout(() => t.classList.remove('show'), 2600);
  }
  R.toast = toast;

  /* ---------- carrinho (carrinho real da loja) ---------- */
  const json = (url, corpo) => fetch(url, {
    method: corpo ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: corpo ? JSON.stringify(corpo) : undefined
  }).then(async r => {
    const dados = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(dados.description || dados.message || 'Não foi possível atualizar o carrinho.');
    return dados;
  });
  const urlJs = base => base.replace(/\/?$/, '') + '.js';

  const carrinho = {
    dados: null,
    async atualizar() {
      try { this.dados = await json(urlJs(rota('carrinho', '/cart'))); render(); } catch (e) { /* sem rede: mantém o que já está na tela */ }
      /* avisa a página (ex.: desconto progressivo nos cartões de quantidade) a cada mudança do carrinho */
      document.dispatchEvent(new CustomEvent('ravu:carrinho', { detail: this.dados }));
      return this.dados;
    },
    async adicionar(itens, { abrirGaveta = true } = {}) {
      await json(urlJs(rota('adicionar', '/cart/add')), { items: itens });
      await this.atualizar();
      if (abrirGaveta) abrir('cart');
      return this.dados;
    },
    async alterar(chave, quantidade) {
      await json(urlJs(rota('alterar', '/cart/change')), { id: chave, quantity: quantidade });
      return this.atualizar();
    },
    async atualizarVarios(corpo) {
      await json(urlJs(rota('atualizar', '/cart/update')), corpo);
      return this.atualizar();
    }
  };
  R.carrinho = carrinho;

  /* sugestão do carrinho, em ordem de prioridade (igual ao protótipo):
     1) trocar potes avulsos pelo combo, quando o combo sai mais barato
     2) completar o frete grátis, quando falta pouco
     3) o produto que combina com o último adicionado */
  function sugestao(itens, falta) {
    const avulsos = itens.filter(i => porHandle(i.handle)?.tipo === 'avulso');
    const noCarrinho = new Set(avulsos.map(i => i.handle));
    for (const c of catalogo) {
      if (c.tipo !== 'combo' || !c.disponivel || !c.itens?.length) continue;
      const precisa = c.itens.filter(([, , bonus]) => !bonus).map(([h]) => h);
      if (c.itens.some(([, , bonus]) => bonus) || new Set(precisa).size < 2 || !precisa.every(h => noCarrinho.has(h))) continue;
      const soma = precisa.reduce((t, h) => t + (porHandle(h)?.preco || 0), 0);
      /* com o desconto progressivo, os mesmos potes avulsos já saem com 10% ou 15%: o combo só é sugerido se ainda for mais barato */
      const pd = C.progressivo ? C.descontoProg || {} : {};
      const pctAvulsos = !C.progressivo ? 0 : precisa.length >= 3 ? +pd[3] || 0 : precisa.length === 2 ? +pd[2] || 0 : 0;
      const agora = Math.round(soma * (100 - pctAvulsos) / 100);
      const v = c.variantes[c.variante];
      if (v && agora - v.preco > 0) return { tipo: 'combo', combo: c, rotulo: 'Mais economia', titulo: `Troque pelo ${c.titulo}`, texto: `Mesmos produtos, ${brl(agora - v.preco)} a menos`, imagem: c.imagem, cta: 'Trocar' };
    }
    const tem = new Set(itens.map(i => i.handle));
    const nosCombos = new Set(itens.flatMap(i => (porHandle(i.handle)?.itens || []).map(([h]) => h)));
    const livres = catalogo.filter(p => p.tipo === 'avulso' && p.disponivel && !tem.has(p.handle) && !nosCombos.has(p.handle));
    if (falta > 0 && falta <= 8000) {
      const cabe = livres.filter(p => p.preco >= falta).sort((a, b) => a.preco - b.preco)[0];
      if (cabe) return { tipo: 'add', produto: cabe, rotulo: 'Frete grátis', titulo: cabe.titulo, texto: `Adicione e ganhe frete grátis · ${brl(cabe.preco)}`, imagem: cabe.imagem, cta: 'Adicionar' };
    }
    const ultimo = [...itens].reverse().map(i => porHandle(i.handle)).find(Boolean);
    const comp = ultimo?.tipo === 'avulso' && porHandle(ultimo.complemento);
    const escolha = (comp && livres.includes(comp) && comp) || livres.find(p => p.linha === ultimo?.linha) || livres[0];
    if (escolha) return { tipo: 'add', produto: escolha, rotulo: 'Combina com seu pedido', titulo: escolha.titulo, texto: brl(escolha.preco), imagem: escolha.imagem, cta: 'Adicionar' };
    return null;
  }
  let sugestaoAtual = null;
  let freteCarFeito = null;

  const icCaminhao = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v8H2z"/><path d="M13 10h4l3 3v2h-7z"/><circle cx="6" cy="17" r="1.7"/><circle cx="16.5" cy="17" r="1.7"/></svg>';
  const icCoracao = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
  const icCadeado = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  const fotoPequena = (url, w = 160) => url ? url.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '') + (url.includes('?') ? '&' : '?') + `width=${w}` : '';

  function render() {
    const d = carrinho.dados;
    if (!d) return;
    const itens = d.items || [];
    const qtd = d.item_count || 0;
    $$('#cartCount, [data-cart-count]').forEach(el => { el.textContent = qtd || ''; });
    const cab = $('#cartHeadCount');
    if (cab) cab.textContent = qtd ? `(${qtd})` : '';
    const corpo = $('#cartBody'), pe = $('#cartFoot'), barra = $('#shipBar');
    if (!corpo) return;

    /* desconto progressivo (Yampi · Leve mais, pague menos): soma todos os potes avulsos do carrinho (combos fora);
       2 potes = desconto de 2, 3 ou mais = desconto de 3. Só mostra: quem desconta de verdade é a Yampi, no checkout. */
    const P = C.progressivo ? C.descontoProg || {} : null;
    let qtdAvulsos = 0, baseAvulsos = 0;
    /* potes em promoção própria (campo "Fora do desconto progressivo", ex.: Pump a 20%, 25/10) não contam nem ganham o progressivo */
    if (P) itens.forEach(i => { const p = porHandle(i.handle); if (p && p.tipo !== 'combo' && !p.semProg) { qtdAvulsos += i.quantity; baseAvulsos += i.final_line_price; } });
    const pctDe = q => !P ? 0 : q >= 3 ? +P[3] || 0 : q === 2 ? +P[2] || 0 : 0;
    const pctProg = pctDe(qtdAvulsos);
    const descProg = Math.round(baseAvulsos * pctProg / 100);
    const proxPct = P && qtdAvulsos > 0 && qtdAvulsos < 3 ? pctDe(qtdAvulsos + 1) : 0;
    const total = d.total_price - descProg;
    const falta = C.freteGratis ? Math.max(0, C.freteGratis - total) : 0;
    if (barra) {
      barra.hidden = !itens.length || !C.freteGratis;
      const feito = falta === 0 && total > 0;
      barra.classList.toggle('done', feito);
      const pct = C.freteGratis ? Math.min(1, total / C.freteGratis) : 1;
      /* festa (🥳 + coraçõezinhos) quando o pedido passa do frete grátis; depois o caminhão vira coração */
      const festa = feito && freteCarFeito === false && !calmo;
      if (itens.length) freteCarFeito = feito;
      barra.innerHTML = `<span>${falta === 0 ? 'Oba! Seu frete é <b>grátis</b>' : `Faltam <b>${brl(falta)}</b> para o frete grátis`}</span>
        <div class="rail${festa ? ' festa' : ''}" style="--p:${pct}"><div class="track"><div class="fill"></div></div>
        <span class="marker${falta === 0 ? ' done' : ''}" aria-hidden="true">${festa ? '<span class="emoji">🥳</span>' : falta === 0 ? icCoracao : icCaminhao}</span>
        <span class="burst" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span></div>`;
      if (festa) setTimeout(() => {
        const m = $('#shipBar .marker');
        if (m && freteCarFeito) m.innerHTML = icCoracao;
        $('#shipBar .rail')?.classList.remove('festa');
      }, 1700);
    }

    if (!itens.length) {
      const quiz = $('#quiz') ? '<button type="button" class="link" data-open="quiz">Fazer o quiz</button>' : '';
      corpo.innerHTML = `<div class="cart-empty"><b>Seu carrinho está vazio</b><p class="muted">Que tal começar pela goma do seu objetivo?</p><a class="btn dark" href="${rota('todos', '/collections/all')}">Ver produtos</a>${quiz}</div>`;
      if (pe) pe.innerHTML = '';
      sugestaoAtual = null;
      return;
    }

    sugestaoAtual = sugestao(itens, falta);
    const sg = sugestaoAtual;
    let cheioTotal = 0;
    corpo.innerHTML = itens.map(i => {
      const p = porHandle(i.handle);
      const v = p?.variantes?.[i.variant_id];
      const cheio = Math.max((v?.cheio || 0) * i.quantity, i.original_line_price);
      cheioTotal += cheio;
      const props = Object.entries(i.properties || {}).filter(([k, val]) => val && !k.startsWith('_')).map(([, val]) => val);
      let variante = i.variant_title && !/default title/i.test(i.variant_title) ? i.variant_title : '';
      /* combo com sabores misturados: o sabor vem da propriedade, então mostra só a opção do kit */
      if (props.length && (p?.tipo === 'combo' || i.properties?.Sabores)) variante = variante.split(' / ').pop();
      const descontos = (i.line_level_discount_allocations || []).map(a => a.discount_application?.title).filter(Boolean);
      const sub = [variante, ...props].filter(Boolean).join(' · ') || (p?.tipo === 'combo' ? 'Combo' : '1 pote');
      return `<div class="citem">
        <a href="${esc(i.url)}">${i.image ? `<img src="${esc(fotoPequena(i.image))}" alt="">` : ''}</a>
        <div class="ci">
          <b>${esc(p?.titulo || i.product_title)}</b><small>${esc(sub)}</small>${descontos.length ? `<small style="color:var(--ok);font-weight:600">${esc(descontos.join(' · '))}</small>` : ''}
          <div class="ctrl">
            <div class="qty"><button type="button" aria-label="Diminuir" data-q="${esc(i.key)}" data-d="-1">−</button><span>${i.quantity}</span><button type="button" aria-label="Aumentar" data-q="${esc(i.key)}" data-d="1">+</button></div>
            <button type="button" class="rm" data-q="${esc(i.key)}" data-d="rm">Remover</button>
          </div>
        </div>
        <div class="price-col">${cheio > i.final_line_price ? `<s>${brl(cheio)}</s>` : ''}${brl(i.final_line_price)}</div>
      </div>`;
    }).join('') + (sg ? `
      <div class="upsell${sg.tipo === 'combo' ? ' combo' : ''}">
        <img src="${esc(fotoPequena(sg.imagem))}" alt="">
        <div><small>${esc(sg.rotulo)}</small><b>${esc(sg.titulo)}</b><span>${esc(sg.texto)}</span></div>
        <button type="button" data-suggest>${esc(sg.cta)}</button>
      </div>` : '');

    if (!pe) return;
    const subtotal = d.items_subtotal_price;
    const economia = cheioTotal - subtotal;
    const cupons = (d.discount_codes || []).filter(c => c.applicable);
    const cupomDesconto = (d.cart_level_discount_applications || []).reduce((t, a) => t + (a.total_allocated_amount || 0), 0);
    const cupomTexto = cupons.map(c => c.code).join(', ') || (d.cart_level_discount_applications || []).map(a => a.title).join(', ');
    /* os cupons da RAVU ficam na Yampi (checkout), não na Shopify: o carrinho só explica onde usar */
    pe.innerHTML = `
      <details class="coupon-wrap"><summary>Tem um cupom?</summary>
        <p class="muted" style="font-size:13px;margin-top:6px">Você coloca o cupom na próxima etapa: toque em <b>Finalizar compra</b> e use o campo <b>Cupom</b> do pagamento.</p></details>
      ${proxPct > pctProg ? `<p class="prog-falta">Falta <b>1 pote</b> para ganhar <b>${proxPct}% OFF</b> em todos os potes</p>` : ''}
      <div class="rows">
        <div class="row"><span>Subtotal</span><span>${economia > 0 ? `<s>${brl(cheioTotal)}</s> ` : ''}${brl(subtotal)}</span></div>
        ${economia > 0 ? `<div class="row save"><span>Você economizou</span><span>${brl(economia)}</span></div>` : ''}
        ${descProg ? `<div class="row save"><span>Leve mais, pague menos (${pctProg}% OFF)</span><span>−${brl(descProg)}</span></div>` : ''}
        ${cupomDesconto ? `<div class="row save"><span>Cupom ${esc(cupomTexto)}</span><span>−${brl(cupomDesconto)}</span></div>` : ''}
        <div class="row"><span>Frete</span><span>${C.freteGratis && falta === 0 ? '<b class="free">Grátis</b>' : 'Informe o CEP na etapa de entrega'}</span></div>
        <div class="row total"><span>Total</span><span>${brl(total)}</span></div>
        <div class="row inst"><span></span><span>${parcela(total)}</span></div>
      </div>
      <a class="btn block cart-cta" href="/checkout">${icCadeado}<span>Finalizar compra</span></a>
      <button type="button" class="keep" data-close>Continuar comprando</button>
      <p class="pay-icons">Pix · Cartão · Boleto · Compra 100% segura</p>`;
  }

  let ocupado = false;
  const trabalhar = async (fn, ok) => {
    if (ocupado) return;
    ocupado = true;
    $('#cart .panel')?.classList.add('is-loading');
    try { await fn(); if (ok) toast(ok); } catch (e) { toast(e.message); await carrinho.atualizar(); }
    finally { ocupado = false; $('#cart .panel')?.classList.remove('is-loading'); }
  };
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-q]');
    if (q) {
      const item = carrinho.dados?.items.find(i => i.key === q.dataset.q);
      if (!item) return;
      const nova = q.dataset.d === 'rm' ? 0 : Math.max(0, item.quantity + Number(q.dataset.d));
      trabalhar(() => carrinho.alterar(item.key, nova));
      return;
    }
    if (e.target.closest('[data-suggest]') && sugestaoAtual) {
      const sg = sugestaoAtual;
      if (sg.tipo === 'combo') {
        /* tira 1 pote avulso de cada item do combo e coloca o combo */
        trabalhar(async () => {
          const updates = {};
          sg.combo.itens.forEach(([h]) => {
            const it = carrinho.dados.items.find(i => i.handle === h && updates[i.key] === undefined);
            if (it) updates[it.key] = it.quantity - 1;
          });
          await carrinho.atualizarVarios({ updates });
          await carrinho.adicionar([{ id: sg.combo.variante, quantity: 1 }], { abrirGaveta: false });
        }, `Trocado pelo ${sg.combo.titulo}`);
      } else {
        trabalhar(() => carrinho.adicionar([{ id: sg.produto.variante, quantity: 1 }], { abrirGaveta: false }), 'Adicionado ao carrinho');
      }
      return;
    }
    if (e.target.closest('[data-tirar-cupom]')) {
      trabalhar(() => carrinho.atualizarVarios({ discount: '' }), 'Cupom removido');
    }
  });
  document.addEventListener('submit', e => {
    if (e.target.id !== 'couponForm') return;
    e.preventDefault();
    const codigo = e.target.c.value.trim().toUpperCase();
    if (!codigo) return;
    trabalhar(async () => {
      await carrinho.atualizarVarios({ discount: codigo });
      const ok = (carrinho.dados.discount_codes || []).find(c => c.code.toUpperCase() === codigo && c.applicable);
      toast(ok ? 'Cupom aplicado' : 'Cupom inválido para este carrinho');
    });
  });
  /* outras abas ou o botão "voltar" do navegador: confere o carrinho de novo */
  addEventListener('pageshow', e => { if (e.persisted) carrinho.atualizar(); });
  document.addEventListener('DOMContentLoaded', () => carrinho.atualizar());

  /* ---------- Compra rápida (barra do celular, snippet ravu-compra-rapida) ----------
     O cliente escolhe a quantidade de cada pote/sabor (variação de 1 unidade) e adiciona tudo de uma vez.
     Com o desconto progressivo, mostra o desconto do pedido contando também os potes avulsos que já estão no carrinho. */
  const qb = $('#compra');
  if (qb) {
    const escolha = {};
    const linhasQb = $$('[data-qb-row]', qb);
    const PQ = C.progressivo ? C.descontoProg || {} : null;
    const pctQ = q => !PQ ? 0 : q >= 3 ? +PQ[3] || 0 : q === 2 ? +PQ[2] || 0 : 0;
    const potesNoCarrinho = () => (carrinho.dados?.items || []).filter(i => { const p = porHandle(i.handle); return p && p.tipo !== 'combo' && !p.semProg; }).reduce((t, i) => t + i.quantity, 0);
    const plural = n => `${n} ${n > 1 ? 'potes' : 'pote'}`;
    /* barra de frete grátis (rosa): total do pedido = combos do carrinho + todos os potes avulsos (carrinho + escolhidos) com o desconto.
       Ao passar do valor do frete grátis: festa (🥳 + coraçõezinhos) e o caminhão vira coração. */
    const freteBarra = $('[data-qb-ship]', qb);
    let freteFeito = null;
    const pintarFrete = (base, n, noCar, fixo = 0) => {
      if (!freteBarra || !C.freteGratis) return;
      let combosCar = 0, avulsosCar = 0;
      (carrinho.dados?.items || []).forEach(i => { const p = porHandle(i.handle); if (p && p.tipo !== 'combo' && !p.semProg) avulsosCar += i.final_line_price; else combosCar += i.final_line_price; });
      const pedido = combosCar + fixo + Math.round((avulsosCar + base) * (100 - pctQ(n + noCar)) / 100);
      const falta = Math.max(0, C.freteGratis - pedido);
      const feito = pedido > 0 && falta === 0;
      const trilho = $('[data-qb-ship-rail]', freteBarra);
      const marca = $('[data-qb-ship-marker]', freteBarra);
      trilho.style.setProperty('--p', Math.min(1, pedido / C.freteGratis));
      $('[data-qb-ship-txt]', freteBarra).innerHTML = !pedido
        ? `Frete grátis acima de <b>${brl(C.freteGratis).replace(',00', '')}</b>`
        : feito ? 'Oba! Seu frete é <b>grátis</b>' : `Faltam <b>${brl(falta)}</b> para o frete grátis`;
      freteBarra.classList.toggle('done', feito);
      if (feito === freteFeito) return;
      /* festa só com o painel aberto (quando a própria cliente chega no valor) */
      const festa = feito && freteFeito === false && !calmo && qb.classList.contains('open');
      freteFeito = feito;
      marca.classList.toggle('done', feito);
      if (!festa) { marca.innerHTML = feito ? icCoracao : icCaminhao; return; }
      marca.innerHTML = '<span class="emoji">🥳</span>';
      trilho.classList.remove('festa');
      void trilho.offsetWidth;
      trilho.classList.add('festa');
      setTimeout(() => { if (freteFeito) marca.innerHTML = icCoracao; trilho.classList.remove('festa'); }, 1700);
    };
    const pintarQb = () => {
      /* n e base: só os potes do progressivo; nFixo e baseFixo: potes em promoção própria (data-sem-prog), sempre com o preço deles */
      let n = 0, base = 0, nFixo = 0, baseFixo = 0;
      linhasQb.forEach(l => { const q = escolha[l.dataset.variante] || 0; if (l.dataset.semProg) { nFixo += q; baseFixo += q * +l.dataset.preco; } else { n += q; base += q * +l.dataset.preco; } });
      const noCar = potesNoCarrinho();
      /* o desconto que cada pote terá: o do pedido inteiro (escolhidos + carrinho); sem nada escolhido, o de 1 pote a mais */
      const pct = pctQ(Math.max(n, 1) + noCar);
      linhasQb.forEach(l => {
        const q = escolha[l.dataset.variante] || 0;
        l.querySelector('[data-qtd]').textContent = q;
        l.classList.toggle('on', q > 0);
        const preco = +l.dataset.preco;
        const cheioL = +l.dataset.cheio || 0;
        l.querySelector('[data-qb-preco]').innerHTML = l.dataset.semProg
          ? (cheioL > preco ? `<s>${brl(cheioL)}</s>${brl(preco)}` : brl(preco))
          : pct ? `<s>${brl(preco)}</s>${brl(Math.round(preco * (100 - pct) / 100))}` : brl(preco);
      });
      const descQ = n ? Math.round(base * pctQ(n + noCar) / 100) : 0;
      const prox = PQ && n > 0 && n + noCar < 3 ? pctQ(n + noCar + 1) : 0;
      const dica = $('[data-qb-dica]', qb);
      const partes = [];
      if (noCar && PQ) partes.push(`Você já tem <b>${plural(noCar)}</b> no carrinho: eles contam para o desconto.`);
      if (prox) partes.push(`Falta <b>1 pote</b> para ganhar <b>${prox}% OFF</b> em todos os potes.`);
      dica.innerHTML = partes.join('<br>');
      pintarFrete(base, n, noCar, baseFixo);
      dica.hidden = !partes.length;
      /* resumo: total com o preço cheio riscado, "N potes · X% OFF · limpar" e o botão compacto */
      const nTot = n + nFixo;
      $('[data-qb-resumo]', qb).classList.toggle('vazio', !nTot);
      $('[data-qb-total]', qb).textContent = nTot ? brl(base - descQ + baseFixo) : 'Escolha seus potes';
      $('[data-qb-cheio]', qb).textContent = descQ ? brl(base + baseFixo) : '';
      $('[data-qb-info]', qb).innerHTML = nTot
        ? `${plural(nTot)}${descQ ? ` · ${pctQ(n + noCar)}% OFF` : ''} · <button type="button" data-qb-limpar>limpar</button>`
        : 'Toque no + para começar';
      $('[data-qb-add]', qb).disabled = !nTot;
    };
    qb.addEventListener('click', async e => {
      /* "Ver combos": fecha a Compra rápida antes de abrir o painel dos combos */
      if (e.target.closest('[data-open="combos"]')) { fechar(qb); return; }
      const linha = e.target.closest('[data-qb-row]');
      if (linha && e.target.closest('[data-qb-mais], [data-qb-menos]')) {
        const id = linha.dataset.variante;
        escolha[id] = Math.max(0, Math.min(20, (escolha[id] || 0) + (e.target.closest('[data-qb-mais]') ? 1 : -1)));
        pintarQb();
        return;
      }
      if (e.target.closest('[data-qb-limpar]')) { Object.keys(escolha).forEach(k => delete escolha[k]); pintarQb(); return; }
      const botao = e.target.closest('[data-qb-add]');
      if (!botao || botao.disabled) return;
      const itens = Object.entries(escolha).filter(([, q]) => q > 0).map(([id, q]) => ({ id: +id, quantity: q }));
      botao.disabled = true;
      qb.querySelector('.panel').classList.add('is-loading');
      try {
        await carrinho.adicionar(itens, { abrirGaveta: false });
        Object.keys(escolha).forEach(k => delete escolha[k]);
        fechar(qb);
        abrir('cart');
      } catch (erro) {
        toast(erro.message);
      } finally {
        qb.querySelector('.panel').classList.remove('is-loading');
        pintarQb();
      }
    });
    document.addEventListener('ravu:carrinho', pintarQb);
    pintarQb();
  }

  /* ---------- painel Combos (barra do celular): sabor e tamanho de cada combo + "Adicionar" ---------- */
  $$('#combos [data-cc-card]').forEach(card => {
    let variantes = [];
    try { variantes = JSON.parse(card.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    /* abre na opção de MAIOR desconto, como a página do combo (pedido do Thiago, 25/10); empate fica com a 1ª */
    const desconto = v => (v.cheio > v.preco ? (v.cheio - v.preco) / v.cheio : 0);
    const disponiveis = variantes.filter(v => v.disp);
    const primeira = (disponiveis.length ? disponiveis : variantes).reduce((m, v) => (desconto(v) > desconto(m) ? v : m), (disponiveis.length ? disponiveis : variantes)[0]);
    if (!primeira) return;
    /* uma escolha por opção de sabor (s0 = Whey, s1 = Creatina) e o tamanho (q) */
    const escolha = { q: primeira.q };
    (primeira.s || []).forEach((s, k) => { escolha['s' + k] = s; });
    const pintar = () => {
      card.querySelectorAll('[data-cc-op]').forEach(b => {
        const on = escolha[b.dataset.ccOp] === b.dataset.valor;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on);
      });
      const v = variantes.find(x => x.q === escolha.q && (x.s || []).every((s, k) => s === escolha['s' + k]));
      card.atual = v && v.disp ? v : null;
      $('[data-cc-preco]', card).textContent = v ? brl(v.preco) : '';
      $('[data-cc-cheio]', card).textContent = v && v.cheio > v.preco ? brl(v.cheio) : '';
      $('[data-cc-eco]', card).textContent = v && v.cheio > v.preco ? `Economize ${brl(v.cheio - v.preco)}` : '';
      $('[data-cc-add]', card).disabled = !card.atual;
      $('[data-cc-texto]', card).textContent = card.atual ? 'Adicionar' : 'Esgotado';
    };
    card.addEventListener('click', async e => {
      const op = e.target.closest('[data-cc-op]');
      if (op) { escolha[op.dataset.ccOp] = op.dataset.valor; pintar(); return; }
      const botao = e.target.closest('[data-cc-add]');
      if (!botao || !card.atual) return;
      botao.disabled = true;
      try {
        await carrinho.adicionar([{ id: card.atual.id, quantity: 1 }], { abrirGaveta: false });
        fechar($('#combos'));
        abrir('cart');
      } catch (erro) {
        toast(erro.message);
      } finally {
        pintar();
      }
    });
    pintar();
  });

  /* ---------- quiz de boas-vindas ---------- */
  document.addEventListener('click', e => {
    const g = e.target.closest('#quiz [data-goal]');
    if (!g) return;
    const passo = $('#qStep'), res = $('#qResult');
    passo.style.display = 'none';
    res.style.display = 'flex';
    $$('[data-goal-result]', res).forEach(x => { x.hidden = x.dataset.goalResult !== g.dataset.goal; });
  });


  /* ---------- stories da página de produto ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-story]');
    if (!b) return;
    const img = $('#stImg');
    if (!img) return;
    img.className = b.dataset.storyClasse || '';
    img.src = b.dataset.storyFoto;
    $('#stTitle').textContent = b.dataset.storyTitulo;
    $('#stText').textContent = b.dataset.storyTexto;
    const bar = $('#storyModal .bar i');
    if (bar) { bar.style.animation = 'none'; void bar.offsetHeight; bar.style.animation = ''; }
    abrir('storyModal');
  });

  /* ---------- abas de tabela nutricional (troca de sabor) e abas genéricas ---------- */
  document.addEventListener('click', e => {
    const aba = e.target.closest('[data-aba]');
    if (!aba) return;
    /* o grupo mais próximo (abas podem ficar uma dentro da outra: itens do kit › sabores) */
    const grupo = aba.closest('[data-abas], [data-fichas]');
    if (!grupo) return;
    const doGrupo = el => el.closest('[data-abas], [data-fichas]') === grupo;
    $$('[data-aba]', grupo).filter(doGrupo).forEach(b => { const on = b.dataset.aba === aba.dataset.aba; b.classList.toggle('on', on); b.setAttribute('aria-selected', on); });
    $$('[data-painel], [data-ficha]', grupo).filter(el => el.parentElement.closest('[data-abas], [data-fichas]') === grupo).forEach(p => { p.hidden = (p.dataset.painel || p.dataset.ficha) !== aba.dataset.aba; });
    grupo.dispatchEvent(new CustomEvent('ravu:aba', { bubbles: true, detail: aba.dataset.aba }));
  });

  /* ---------- filtros por chips (home: linhas; coleção: objetivos) ---------- */
  document.addEventListener('click', e => {
    const chip = e.target.closest('[data-filtro]');
    if (!chip) return;
    const alvo = document.getElementById(chip.closest('[data-filtros]')?.dataset.filtros);
    if (!alvo) return;
    $$('[data-filtro]', chip.closest('[data-filtros]')).forEach(x => x.classList.toggle('on', x === chip));
    const f = chip.dataset.filtro;
    let n = 0;
    [...alvo.children].forEach(card => {
      const tags = (card.dataset.tags || '').split(' ');
      const mostra = f === 'all' || tags.includes(f);
      card.classList.toggle('hide', !mostra);
      if (mostra) n++;
    });
    alvo.scrollLeft = 0;
    $$(`[data-contagem-de="${alvo.id}"]`).forEach(el => { el.textContent = `${n} ${n === 1 ? 'item' : 'itens'}`; });
    $$(`[data-vazio-de="${alvo.id}"]`).forEach(el => { el.hidden = n > 0; });
    alvo.dispatchEvent(new CustomEvent('ravu:filtro', { bubbles: true, detail: { filtro: f, total: n } }));
  });

  /* ---------- Combos do início andando sozinhos (25/10) ----------
     Anda por script (rolagem), e não por animação, para a pessoa poder mexer: com o mouse em cima para e
     aparecem as setas; o trackpad e o dedo também arrastam. Volta a andar ao tirar o mouse (ou 2,5 s após soltar o dedo).
     A lista vem 2 vezes; ao passar de uma volta, a rolagem pula uma volta para trás sem a pessoa perceber. */
  $$('[data-andar]').forEach(el => {
    const grupo = $('.vit-grupo', el);
    if (!grupo) return;
    $$('[data-copia] a, [data-copia] button', el).forEach(a => a.setAttribute('tabindex', '-1'));
    const dur = parseFloat(el.dataset.andar) || 35;
    const volta = () => grupo.getBoundingClientRect().width;
    let pos = 0, parado = calmo, ultimo = 0, retomar, seta = 0;
    const ajustar = () => {
      const w = volta();
      if (!w || calmo) return;
      if (el.scrollLeft >= w) el.scrollLeft -= w;
      else if (el.scrollLeft < 1) el.scrollLeft += w;
      pos = el.scrollLeft;
    };
    const passo = t => {
      if (ultimo && !parado && !document.hidden) {
        const w = volta();
        if (w) {
          pos += (w / dur) * Math.min(t - ultimo, 100) / 1000;
          if (pos >= w) pos -= w;
          el.scrollLeft = pos;
        }
      }
      ultimo = t;
      requestAnimationFrame(passo);
    };
    const pausar = () => { parado = true; clearTimeout(retomar); };
    const voltar = ms => { clearTimeout(retomar); if (calmo) return; retomar = setTimeout(() => { pos = el.scrollLeft; parado = false; }, ms); };
    const trilho = el.closest('.vit-lado__trilho') || el;
    trilho.addEventListener('mouseenter', pausar);
    trilho.addEventListener('mouseleave', () => voltar(300));
    el.addEventListener('touchstart', pausar, { passive: true });
    el.addEventListener('touchend', () => voltar(2500), { passive: true });
    trilho.addEventListener('focusin', pausar);
    trilho.addEventListener('focusout', () => voltar(300));
    el.addEventListener('scroll', () => { if (parado && Date.now() > seta) ajustar(); }, { passive: true });
    $$('[data-andar-seta]', trilho).forEach(b => b.addEventListener('click', () => {
      const card = $('.pcard', grupo);
      const d = (card ? card.getBoundingClientRect().width + 16 : 300) * +b.dataset.andarSeta;
      const w = volta();
      /* perto das pontas, pula uma volta antes (as duas cópias são iguais), para a seta nunca bater no fim */
      if (!calmo && w) {
        const max = el.scrollWidth - el.clientWidth;
        if (el.scrollLeft + d < 0) el.scrollLeft += w;
        else if (el.scrollLeft + d > max) el.scrollLeft -= w;
      }
      seta = Date.now() + 700;
      el.scrollBy({ left: d, behavior: 'smooth' });
    }));
    requestAnimationFrame(() => { el.scrollLeft = 1; pos = el.scrollLeft; requestAnimationFrame(passo); });
  });

  /* ---------- carrosséis: troca a barra de rolagem por linha de progresso + setas ---------- */
  const RAILS = '.rail, .vcards, .ugc, .ingr, .r-cards, .experts, .videos, .r-track';
  const seta = d => `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="${d}"/></svg>`;
  function melhorarRail(el) {
    if (el.dataset.ctrl || el.closest('.ship-bar')) return;
    el.dataset.ctrl = '1';
    const ctrl = document.createElement('div');
    ctrl.className = 'rail-ctrl';
    ctrl.innerHTML = `<div class="bar"><span class="thumb"></span></div>
      <button type="button" class="prev" aria-label="Voltar">${seta('M15 6l-6 6 6 6')}</button><button type="button" class="next" aria-label="Avançar">${seta('M9 6l6 6-6 6')}</button>`;
    el.after(ctrl);
    const thumb = $('.thumb', ctrl), prev = $('.prev', ctrl), next = $('.next', ctrl);
    const atualizar = () => {
      const max = el.scrollWidth - el.clientWidth;
      ctrl.hidden = max < 8;
      if (ctrl.hidden) return;
      const vis = el.clientWidth / el.scrollWidth;
      thumb.style.width = `${Math.max(12, vis * 100)}%`;
      thumb.style.left = `${(el.scrollLeft / max) * (100 - Math.max(12, vis * 100))}%`;
      prev.disabled = el.scrollLeft < 4;
      next.disabled = el.scrollLeft > max - 4;
    };
    const passo = dir => el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' });
    prev.onclick = () => passo(-1);
    next.onclick = () => passo(1);
    el.addEventListener('scroll', atualizar, { passive: true });
    new ResizeObserver(atualizar).observe(el);
    new MutationObserver(atualizar).observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    atualizar();
  }
  const melhorarTodos = (raiz = document) => $$(RAILS, raiz).filter(el => !el.closest('.drawer')).forEach(melhorarRail);

  /* transição pulada pelo navegador não é erro */
  const quieto = e => { const vt = e.viewTransition; if (vt) { vt.ready?.catch(() => {}); vt.finished?.catch(() => {}); vt.updateCallbackDone?.catch(() => {}); } };
  addEventListener('pageswap', quieto);
  addEventListener('pagereveal', quieto);

  /* troca de página suave nos navegadores sem View Transitions */
  if (!('CSSViewTransitionRule' in window) && !calmo && !C.modoEditor) {
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || a.target || a.hasAttribute('download') || a.closest('[data-open]')) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || url.hash || (url.pathname === location.pathname && url.search === location.search) || url.pathname.startsWith('/checkout')) return;
      e.preventDefault();
      document.documentElement.classList.add('leaving');
      setTimeout(() => { location.href = url.href; }, 180);
    });
    addEventListener('pageshow', () => document.documentElement.classList.remove('leaving'));
  }

  /* menu ganha sombra ao rolar */
  const aoRolar = () => $('.site-header')?.classList.toggle('scrolled', scrollY > 8);
  addEventListener('scroll', aoRolar, { passive: true });

  /* ---------- ponto de foco das fotos (onde está o rosto), pelo nome do arquivo ---------- */
  const FOCO = {
    'f1-hero-desktop': '50% 20%', 'f1-hero-mobile': '50% 25%', 'f4-beneficios': '50% 22%', 'f7-ciencia': '50% 30%', 'f8-zero-friccao': '50% 38%',
    'f10-ritual': '50% 30%', 'f11-linha-glow': '50% 20%', 'f12-linha-move': '50% 15%', 'f13-historia-provisoria-ia': '50% 22%', 'f14-quiz': '50% 25%',
    'IMG_7021': '50% 25%', 'IMG_8584': '50% 20%', 'IMG_8613': '55% 20%', 'IMG_8640': '50% 20%', 'crea_real1': '50% 18%',
    'hair1': '50% 25%', 'hair2': '50% 30%', 'life-crea': '50% 15%', 'life-whey-choco': '45% 15%', 'mel1': '50% 30%', 'mel2': '50% 30%',
    'pump3': '50% 20%', 'potes-ravu-piscina': '50% 45%'
  };
  R.foco = FOCO;
  function focar(img) {
    if (img.tagName !== 'IMG' || (img.style.objectPosition && !img.dataset.foco)) return;
    const nome = decodeURIComponent((img.currentSrc || img.getAttribute('src') || '').split('/').pop().split('?')[0])
      .replace(/\.\w+$/, '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '');
    const f = FOCO[nome];
    if (f) { img.style.objectPosition = f; img.dataset.foco = '1'; }
  }
  const focarTudo = (raiz = document) => $$('img', raiz).forEach(focar);

  /* ---------- movimento ao rolar a página ----------
     [data-reveal] (ou "left", "right", "zoom") aparece ao entrar na tela; filhos de [data-stagger] aparecem um a um;
     [data-words] acende palavra por palavra; [data-count] conta do zero até o número */
  const AUTO_GRUPOS = '[data-vitrine], .trust, .benef-col, .vcards, main .lines, #combos, .ugc, #faq, #benL, #benR, #timeline, #ritual, #ingr, .r-cards, #videos, #faqbig, #related, .kit-cards, .day, .grid-products, .why, .ways';
  const AUTO_BLOCOS = 'main h2, main .sec-sub, main .section .sub, main .story, main .cta-band, main .photo-hero, .nutri-grid > *, .benef .blob, .scoop > *, #pair, :has(> #benImg), :has(> #tlImg), #ntable, .reviews .head';
  let io;
  const contar = el => {
    const alvo = parseFloat(el.dataset.count.replace(',', '.')), casas = (el.dataset.count.split(',')[1] || '').length;
    const pre = el.dataset.pre || '', t0 = performance.now(), dur = 1400;
    const passo = t => {
      const p = Math.min(1, (t - t0) / dur), v = alvo * (1 - Math.pow(1 - p, 3));
      el.textContent = pre + v.toFixed(casas).replace('.', ',');
      if (p < 1) requestAnimationFrame(passo);
    };
    requestAnimationFrame(passo);
  };
  const todos = lista => lista.split(/,\s*(?![^()]*\))/).flatMap(sel => { try { return $$(sel); } catch (e) { return []; } });
  const fora = el => el.closest('.modal, .drawer, header, .promo, .sheet, .sticky-buy, #rail, [data-rail-gomas]');
  function animar() {
    if (C.modoEditor) return;
    todos(AUTO_GRUPOS).forEach(g => { if (!fora(g) && !g.closest('[data-stagger]')) g.setAttribute('data-stagger', ''); });
    todos(AUTO_BLOCOS).forEach(el => {
      if (!fora(el) && !el.closest('[data-reveal], [data-stagger]') && !el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
    });
    $$('[data-stagger]').forEach(g => [...g.children].forEach((c, i) => {
      if (c.dataset.rvVisto) return;
      c.dataset.rvVisto = 1;
      if (!c.hasAttribute('data-reveal')) c.setAttribute('data-reveal', '');
      c.style.setProperty('--i', Math.min(i, 7));
    }));
    $$('[data-words]:not([data-words-ok])').forEach(el => {
      el.dataset.wordsOk = 1;
      let k = 0;
      const partir = n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(w => {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.append(w); return; }
            const s = document.createElement('span'); s.className = 'w'; s.style.setProperty('--i', k++); s.textContent = w; frag.append(s);
          });
          n.replaceWith(frag);
        } else [...n.childNodes].forEach(partir);
      };
      [...el.childNodes].forEach(partir);
    });
    const alvos = $$('[data-reveal], [data-words], [data-count]').filter(el => !el.dataset.rvObs);
    alvos.forEach(el => { el.dataset.rvObs = 1; });
    if (calmo || !('IntersectionObserver' in window)) { alvos.forEach(el => el.classList.add('in', 'rv-ok')); return; }
    document.documentElement.classList.add('rv');
    io = io || new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      const pai = e.target.parentElement;
      const grupo = pai && pai.hasAttribute('data-stagger') && pai.scrollWidth > pai.clientWidth + 4 ? [...pai.children] : [e.target];
      grupo.forEach(x => {
        io.unobserve(x);
        x.classList.add('in');
        if (x.dataset.count) contar(x);
        if (x.hasAttribute('data-reveal')) setTimeout(() => x.classList.add('rv-ok'), 1100 + (+getComputedStyle(x).getPropertyValue('--i') || 0) * 90);
      });
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    alvos.forEach(el => io.observe(el));
  }
  R.animar = animar;

  /* ---------- banner de campanhas: troca sozinha a cada 6 s, setas, bolinhas e arrastar ---------- */
  function banner(box) {
    if (box.dataset.bannerPronto) return;
    box.dataset.bannerPronto = '1';
    const tempo = +box.dataset.tempo || 6000;
    const track = $('.promo-track', box), win = $('.promo-win', box), dots = $('.promo-dots', box);
    const slides = $$('.promo-slide', track);
    const n = slides.length;
    if (!n) return;
    box.style.setProperty('--cor', slides[0].dataset.cor);
    if (n < 2) { box.classList.add('um'); return; }
    const copia = slides[0].cloneNode(true);
    copia.setAttribute('aria-hidden', 'true');
    copia.tabIndex = -1;
    $$('img', copia).forEach(i => { i.loading = 'lazy'; i.removeAttribute('fetchpriority'); });
    track.append(copia);
    box.setAttribute('aria-roledescription', 'carrossel');
    box.style.setProperty('--tempo', tempo + 'ms');
    let i = 0, pos = 0, timer, arrastou = false;
    const mover = (p, suave = true) => {
      track.classList.toggle('drag', !suave);
      track.style.transform = `translateX(${-p * 100}%)`;
      if (!suave) { void track.offsetHeight; track.classList.remove('drag'); }
    };
    track.addEventListener('transitionend', () => { if (pos === n) { pos = 0; mover(0, false); } });
    function ir(k) {
      if (pos === n) { pos = 0; mover(0, false); }
      if (k >= n && pos === n - 1) { pos = n; i = 0; }
      else if (k < 0 && pos === 0) { mover(n, false); pos = n - 1; i = n - 1; }
      else { i = (k + n) % n; pos = i; }
      mover(pos);
      box.style.setProperty('--cor', slides[i].dataset.cor);
      slides.forEach((s, x) => { s.tabIndex = x === i ? 0 : -1; s.setAttribute('aria-hidden', x !== i); });
      $$('button', dots).forEach((d, x) => { d.classList.toggle('on', x === i); d.setAttribute('aria-current', x === i); });
      const bar = $$('button i', dots)[i];
      if (bar) { bar.style.animation = 'none'; void bar.offsetHeight; bar.style.animation = ''; }
      clearTimeout(timer);
      if (!box.classList.contains('pausa')) timer = setTimeout(() => ir(i + 1), tempo);
    }
    const pausar = on => { box.classList.toggle('pausa', on); clearTimeout(timer); if (!on) timer = setTimeout(() => ir(i + 1), tempo); };
    $('.promo-arrow.prev', box).onclick = () => ir(i - 1);
    $('.promo-arrow.next', box).onclick = () => ir(i + 1);
    dots?.addEventListener('click', e => { const b = e.target.closest('button'); if (b) ir($$('button', dots).indexOf(b)); });
    box.addEventListener('mouseenter', () => pausar(true));
    box.addEventListener('mouseleave', () => pausar(false));
    document.addEventListener('visibilitychange', () => pausar(document.hidden));
    box.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') ir(i - 1); if (e.key === 'ArrowRight') ir(i + 1); });
    let x0 = null, dx = 0;
    win.addEventListener('pointerdown', e => { if (e.target.closest('.promo-arrow')) return; x0 = e.clientX; dx = 0; arrastou = false; });
    win.addEventListener('pointermove', e => {
      if (x0 === null) return;
      dx = e.clientX - x0;
      if (Math.abs(dx) > 6) {
        arrastou = true;
        if (pos === n) { pos = 0; mover(0, false); }
        track.classList.add('drag');
        track.style.transform = `translateX(calc(${-pos * 100}% + ${dx}px))`;
        clearTimeout(timer);
      }
    });
    const soltar = () => {
      if (x0 === null) return;
      track.classList.remove('drag'); x0 = null;
      if (arrastou && Math.abs(dx) > win.clientWidth * 0.15) ir(dx < 0 ? i + 1 : i - 1); else ir(i);
    };
    win.addEventListener('pointerup', soltar);
    win.addEventListener('pointercancel', soltar);
    win.addEventListener('pointerleave', soltar);
    track.addEventListener('click', e => { if (arrastou) { e.preventDefault(); arrastou = false; } }, true);
    $$('img', track).forEach(img => { img.draggable = false; });
    ir(0);
  }
  R.banner = banner;


  /* ---------- "Escolha sua goma": cards entram um a um ao aparecer e a cada troca de linha ---------- */
  function railGomas(rail) {
    if (rail.dataset.gomasPronto || calmo || C.modoEditor || !('IntersectionObserver' in window)) return;
    rail.dataset.gomasPronto = '1';
    let fim;
    const entrar = () => {
      const cards = $$('.pcard:not(.hide)', rail);
      clearTimeout(fim);
      rail.classList.add('js-reveal');
      cards.forEach((c, i) => { c.classList.remove('in'); c.style.setProperty('--i', i); });
      void rail.offsetHeight;
      requestAnimationFrame(() => cards.forEach(c => c.classList.add('in')));
      fim = setTimeout(() => { rail.classList.remove('js-reveal'); $$('.pcard', rail).forEach(c => c.classList.remove('in')); }, 750 + cards.length * 110);
    };
    rail.classList.add('js-reveal');
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { obs.disconnect(); entrar(); } }, { threshold: 0.15 });
    obs.observe(rail);
    rail.addEventListener('ravu:filtro', entrar);
  }

  /* ---------- liga tudo (e de novo quando o editor do tema recarrega uma seção) ---------- */
  function ligar(raiz = document) {
    $$('[data-banner]', raiz).forEach(banner);
    $$('[data-rail-gomas]', raiz).forEach(railGomas);
    melhorarTodos(raiz);
    focarTudo(raiz);
    animar();
  }
  R.ligar = ligar;
  document.addEventListener('DOMContentLoaded', () => { aoRolar(); ligar(); });
  addEventListener('load', () => melhorarTodos());
  document.addEventListener('shopify:section:load', e => ligar(e.target));
  new MutationObserver(ms => ms.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1) (n.tagName === 'IMG' ? focar(n) : focarTudo(n)); })))
    .observe(document.documentElement, { subtree: true, childList: true });
})();

/* ---------- Checkout pela Yampi (igual ao tema em produção) ----------
   O arquivo da Yampi (snippets/YampiSnippet.liquid) só reconhece os botões de
   finalizar do tema antigo. Aqui os botões "Finalizar compra" do tema novo
   (gaveta e página do carrinho) chamam a mesma função da Yampi, que manda o
   carrinho para ela e abre o checkout da Yampi. Sem a Yampi carregada, segue
   o checkout normal. Os botões que a própria Yampi cria (.ymp_elem_mainBtn)
   já funcionam sozinhos e não são tocados. */
document.addEventListener(
  'click',
  (e) => {
    const botao = e.target.closest('a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], .cart-cta');
    if (!botao || botao.classList.contains('ymp_elem_mainBtn')) return;
    if (typeof window.yampiClick !== 'function') return;
    e.preventDefault();
    e.stopPropagation();
    window.yampiClick();
  },
  true
);

/* faixa de miniaturas da galeria (produto e combo): com muitas fotos ela rola de lado.
   A miniatura ativa acompanha a foto principal e a borda esmaece do lado onde há mais fotos (revisão de 19/10). */
document.querySelectorAll('[data-thumbs]').forEach((faixa) => {
  const janela = (faixa.closest('.media') || faixa.parentElement).querySelector('[data-window]');
  const bordas = () => {
    const mais = faixa.scrollWidth > faixa.clientWidth + 2;
    faixa.classList.toggle('fade-dir', mais && faixa.scrollLeft + faixa.clientWidth < faixa.scrollWidth - 2);
    faixa.classList.toggle('fade-esq', mais && faixa.scrollLeft > 2);
  };
  faixa.addEventListener('scroll', bordas, { passive: true });
  addEventListener('resize', bordas);
  addEventListener('load', bordas);
  bordas();
  if (!janela) return;
  let espera;
  janela.addEventListener('scroll', () => {
    clearTimeout(espera);
    espera = setTimeout(() => {
      const on = faixa.querySelector('.on');
      if (!on || faixa.scrollWidth <= faixa.clientWidth + 2) return;
      const r = on.getBoundingClientRect();
      const f = faixa.getBoundingClientRect();
      faixa.scrollTo({ left: faixa.scrollLeft + (r.left - f.left) - (faixa.clientWidth - r.width) / 2, behavior: 'smooth' });
    }, 150);
  }, { passive: true });
});
